/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConvertLeadToPersonCommand,
  GetFacetsResponse,
  GetGenericListCommandDto,
  GetLeadTemplatePreviewCommand,
  MaterialiserLeadCbnoCommand,
  MaterialiserLeadCbnoResponse,
  OperationResponse,
  SearchLeads400Response,
  SearchLeadsExternesResponse,
  SearchLeadsResponse,
  SendLeadEmailTemporaryCommand,
  TemplatePreviewResponse,
} from '../models/index';
import {
    ConvertLeadToPersonCommandFromJSON,
    ConvertLeadToPersonCommandToJSON,
    GetFacetsResponseFromJSON,
    GetFacetsResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
    GetLeadTemplatePreviewCommandFromJSON,
    GetLeadTemplatePreviewCommandToJSON,
    MaterialiserLeadCbnoCommandFromJSON,
    MaterialiserLeadCbnoCommandToJSON,
    MaterialiserLeadCbnoResponseFromJSON,
    MaterialiserLeadCbnoResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    SearchLeads400ResponseFromJSON,
    SearchLeads400ResponseToJSON,
    SearchLeadsExternesResponseFromJSON,
    SearchLeadsExternesResponseToJSON,
    SearchLeadsResponseFromJSON,
    SearchLeadsResponseToJSON,
    SendLeadEmailTemporaryCommandFromJSON,
    SendLeadEmailTemporaryCommandToJSON,
    TemplatePreviewResponseFromJSON,
    TemplatePreviewResponseToJSON,
} from '../models/index';

export interface ConvertLeadToPersonRequest {
    convertLeadToPersonCommand: ConvertLeadToPersonCommand;
}

export interface GetLeadTemplatePreviewRequest {
    getLeadTemplatePreviewCommand: GetLeadTemplatePreviewCommand;
}

export interface GetLeadsExternesRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetLeadsExternesFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface MaterialiserLeadExterneCbnoRequest {
    materialiserLeadCbnoCommand: MaterialiserLeadCbnoCommand;
}

export interface MaterialiserLeadExterneEmprunteurRequest {
    materialiserLeadCbnoCommand: MaterialiserLeadCbnoCommand;
}

export interface MaterialiserLeadExterneGliRequest {
    materialiserLeadCbnoCommand: MaterialiserLeadCbnoCommand;
}

export interface SearchLeadsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface SendLeadEmailTemporaryRequest {
    sendLeadEmailTemporaryCommand: SendLeadEmailTemporaryCommand;
}

/**
 * 
 */
export class LeadsApi extends runtime.BaseAPI {

    /**
     * Convert a lead to a natural person and assign it to a broker
     * Convert lead to person
     */
    async convertLeadToPersonRaw(requestParameters: ConvertLeadToPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['convertLeadToPersonCommand'] == null) {
            throw new runtime.RequiredError(
                'convertLeadToPersonCommand',
                'Required parameter "convertLeadToPersonCommand" was null or undefined when calling convertLeadToPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/leads/convert`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConvertLeadToPersonCommandToJSON(requestParameters['convertLeadToPersonCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Convert a lead to a natural person and assign it to a broker
     * Convert lead to person
     */
    async convertLeadToPerson(requestParameters: ConvertLeadToPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.convertLeadToPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * TEMPORARY - Get email template preview for a lead with resolved variables
     * Get lead template preview (temporary)
     */
    async getLeadTemplatePreviewRaw(requestParameters: GetLeadTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TemplatePreviewResponse>> {
        if (requestParameters['getLeadTemplatePreviewCommand'] == null) {
            throw new runtime.RequiredError(
                'getLeadTemplatePreviewCommand',
                'Required parameter "getLeadTemplatePreviewCommand" was null or undefined when calling getLeadTemplatePreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/leads/template-preview-temporary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetLeadTemplatePreviewCommandToJSON(requestParameters['getLeadTemplatePreviewCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TemplatePreviewResponseFromJSON(jsonValue));
    }

    /**
     * TEMPORARY - Get email template preview for a lead with resolved variables
     * Get lead template preview (temporary)
     */
    async getLeadTemplatePreview(requestParameters: GetLeadTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TemplatePreviewResponse> {
        const response = await this.getLeadTemplatePreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liste paginée des leads externes (prospects captés chez un partenaire apporteur). Permission BackOffice.Leads.Manage. Périmètre SERVEUR : gestionnaire = leads de son plateforme traitante, admin = tout — le front n\'envoie aucun scope (plateformeIds n\'a d\'effet qu\'en admin). searchString porte sur nom, prénom, email, téléphone et code tunnel. Tris (sortBy) : date (défaut, desc) | status | branch | subscriber | plateforme (= partenaire apporteur) | broker. 
     * Lister les leads externes
     */
    async getLeadsExternesRaw(requestParameters: GetLeadsExternesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchLeadsExternesResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getLeadsExternes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/leads-externes/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchLeadsExternesResponseFromJSON(jsonValue));
    }

    /**
     * Liste paginée des leads externes (prospects captés chez un partenaire apporteur). Permission BackOffice.Leads.Manage. Périmètre SERVEUR : gestionnaire = leads de son plateforme traitante, admin = tout — le front n\'envoie aucun scope (plateformeIds n\'a d\'effet qu\'en admin). searchString porte sur nom, prénom, email, téléphone et code tunnel. Tris (sortBy) : date (défaut, desc) | status | branch | subscriber | plateforme (= partenaire apporteur) | broker. 
     * Lister les leads externes
     */
    async getLeadsExternes(requestParameters: GetLeadsExternesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchLeadsExternesResponse> {
        const response = await this.getLeadsExternesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Facettes de la liste des leads externes (même payload que la liste). Clés : statuses, branches, partnerPlateformes, plateformes (admin uniquement), brokers, period (daterange). Chaque facette est calculée SANS son propre filtre : elle continue de proposer ses autres options une fois un choix fait. Permission BackOffice.Leads.Manage. 
     * Facettes de la liste des leads externes
     */
    async getLeadsExternesFacetsRaw(requestParameters: GetLeadsExternesFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getLeadsExternesFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/leads-externes/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes de la liste des leads externes (même payload que la liste). Clés : statuses, branches, partnerPlateformes, plateformes (admin uniquement), brokers, period (daterange). Chaque facette est calculée SANS son propre filtre : elle continue de proposer ses autres options une fois un choix fait. Permission BackOffice.Leads.Manage. 
     * Facettes de la liste des leads externes
     */
    async getLeadsExternesFacets(requestParameters: GetLeadsExternesFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getLeadsExternesFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Matérialise un lead externe CBNO en simulation affectée au courtier choisi. La simulation est immédiatement visible dans la liste des simulations de ce courtier. Les erreurs MÉTIER arrivent en HTTP 200 avec success=false (lead déjà converti, affecté à un autre courtier, courtier hors plateforme, lead non CBNO). Permission BackOffice.Leads.Manage. 
     * Convertir un lead externe CBNO en simulation
     */
    async materialiserLeadExterneCbnoRaw(requestParameters: MaterialiserLeadExterneCbnoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaterialiserLeadCbnoResponse>> {
        if (requestParameters['materialiserLeadCbnoCommand'] == null) {
            throw new runtime.RequiredError(
                'materialiserLeadCbnoCommand',
                'Required parameter "materialiserLeadCbnoCommand" was null or undefined when calling materialiserLeadExterneCbno().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/leads-externes/materialiser/cbno`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MaterialiserLeadCbnoCommandToJSON(requestParameters['materialiserLeadCbnoCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MaterialiserLeadCbnoResponseFromJSON(jsonValue));
    }

    /**
     * Matérialise un lead externe CBNO en simulation affectée au courtier choisi. La simulation est immédiatement visible dans la liste des simulations de ce courtier. Les erreurs MÉTIER arrivent en HTTP 200 avec success=false (lead déjà converti, affecté à un autre courtier, courtier hors plateforme, lead non CBNO). Permission BackOffice.Leads.Manage. 
     * Convertir un lead externe CBNO en simulation
     */
    async materialiserLeadExterneCbno(requestParameters: MaterialiserLeadExterneCbnoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MaterialiserLeadCbnoResponse> {
        const response = await this.materialiserLeadExterneCbnoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Matérialise un lead externe EMP (assurance emprunteur) en dossier emprunteur affecté au courtier choisi : projet, prêts, assurés et profils sont créés, mais AUCUNE tarification n\'est déclenchée (le courtier tarife depuis le comparateur) — ne pas afficher de prix issu de cette réponse. La redirection se fait sur projectId (niveau projet), pas sur riskId. riskIds contient un risque par assuré (1 ou 2), dans l\'ordre des assurés du lead ; riskId et fileReference désignent l\'assuré de rang 1 (celui tracé sur le lead). Opération transactionnelle et NON rejouable : pas de retry automatique, bouton désactivé pendant l\'appel (un lead converti est refusé au second appel). Erreurs métier (HTTP 200, success=false) : CHAMP_REQUIS (leadId/brokerId absent), VALEUR_INVALIDE (lead introuvable, déjà converti, affecté à un autre courtier, branche != EMP, courtier introuvable ou hors plateforme traitante, contexte du lead illisible), CONFIGURATION_PARTENAIRE (référentiel incomplet côté Confiancia). errors[].field est absent sur cette route — ne pas cibler de champ. Permission BackOffice.Leads.Manage. 
     * Convertir un lead externe emprunteur en simulation
     */
    async materialiserLeadExterneEmprunteurRaw(requestParameters: MaterialiserLeadExterneEmprunteurRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaterialiserLeadCbnoResponse>> {
        if (requestParameters['materialiserLeadCbnoCommand'] == null) {
            throw new runtime.RequiredError(
                'materialiserLeadCbnoCommand',
                'Required parameter "materialiserLeadCbnoCommand" was null or undefined when calling materialiserLeadExterneEmprunteur().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/leads-externes/materialiser/emprunteur`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MaterialiserLeadCbnoCommandToJSON(requestParameters['materialiserLeadCbnoCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MaterialiserLeadCbnoResponseFromJSON(jsonValue));
    }

    /**
     * Matérialise un lead externe EMP (assurance emprunteur) en dossier emprunteur affecté au courtier choisi : projet, prêts, assurés et profils sont créés, mais AUCUNE tarification n\'est déclenchée (le courtier tarife depuis le comparateur) — ne pas afficher de prix issu de cette réponse. La redirection se fait sur projectId (niveau projet), pas sur riskId. riskIds contient un risque par assuré (1 ou 2), dans l\'ordre des assurés du lead ; riskId et fileReference désignent l\'assuré de rang 1 (celui tracé sur le lead). Opération transactionnelle et NON rejouable : pas de retry automatique, bouton désactivé pendant l\'appel (un lead converti est refusé au second appel). Erreurs métier (HTTP 200, success=false) : CHAMP_REQUIS (leadId/brokerId absent), VALEUR_INVALIDE (lead introuvable, déjà converti, affecté à un autre courtier, branche != EMP, courtier introuvable ou hors plateforme traitante, contexte du lead illisible), CONFIGURATION_PARTENAIRE (référentiel incomplet côté Confiancia). errors[].field est absent sur cette route — ne pas cibler de champ. Permission BackOffice.Leads.Manage. 
     * Convertir un lead externe emprunteur en simulation
     */
    async materialiserLeadExterneEmprunteur(requestParameters: MaterialiserLeadExterneEmprunteurRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MaterialiserLeadCbnoResponse> {
        const response = await this.materialiserLeadExterneEmprunteurRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Matérialise un lead externe GLI en simulation affectée au courtier choisi. ATTENTION : la simulation est créée SANS locataire (le contrat partenaire n\'en transporte aucune donnée) — le devis restera bloqué tant que le courtier n\'aura pas saisi au moins un locataire solvable. La 1re entrée de fieldsToComplete porte ce bloquant. Erreurs métier (HTTP 200, success=false) : lead déjà converti, affecté à un autre courtier, courtier hors plateforme, INELIGIBLE (loyer mensuel >= 6000 EUR), CHAMP_REQUIS (loyer absent), VALEUR_INVALIDE (lead non GLI — mauvais aiguillage). Permission BackOffice.Leads.Manage. 
     * Convertir un lead externe GLI en simulation
     */
    async materialiserLeadExterneGliRaw(requestParameters: MaterialiserLeadExterneGliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaterialiserLeadCbnoResponse>> {
        if (requestParameters['materialiserLeadCbnoCommand'] == null) {
            throw new runtime.RequiredError(
                'materialiserLeadCbnoCommand',
                'Required parameter "materialiserLeadCbnoCommand" was null or undefined when calling materialiserLeadExterneGli().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/leads-externes/materialiser/gli`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MaterialiserLeadCbnoCommandToJSON(requestParameters['materialiserLeadCbnoCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MaterialiserLeadCbnoResponseFromJSON(jsonValue));
    }

    /**
     * Matérialise un lead externe GLI en simulation affectée au courtier choisi. ATTENTION : la simulation est créée SANS locataire (le contrat partenaire n\'en transporte aucune donnée) — le devis restera bloqué tant que le courtier n\'aura pas saisi au moins un locataire solvable. La 1re entrée de fieldsToComplete porte ce bloquant. Erreurs métier (HTTP 200, success=false) : lead déjà converti, affecté à un autre courtier, courtier hors plateforme, INELIGIBLE (loyer mensuel >= 6000 EUR), CHAMP_REQUIS (loyer absent), VALEUR_INVALIDE (lead non GLI — mauvais aiguillage). Permission BackOffice.Leads.Manage. 
     * Convertir un lead externe GLI en simulation
     */
    async materialiserLeadExterneGli(requestParameters: MaterialiserLeadExterneGliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MaterialiserLeadCbnoResponse> {
        const response = await this.materialiserLeadExterneGliRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search and retrieve a paginated list of leads with optional filtering
     * Search leads
     */
    async searchLeadsRaw(requestParameters: SearchLeadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchLeadsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling searchLeads().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/leads/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchLeadsResponseFromJSON(jsonValue));
    }

    /**
     * Search and retrieve a paginated list of leads with optional filtering
     * Search leads
     */
    async searchLeads(requestParameters: SearchLeadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchLeadsResponse> {
        const response = await this.searchLeadsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * TEMPORARY - Send an email from a lead (POC)
     * Send email from lead (temporary)
     */
    async sendLeadEmailTemporaryRaw(requestParameters: SendLeadEmailTemporaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['sendLeadEmailTemporaryCommand'] == null) {
            throw new runtime.RequiredError(
                'sendLeadEmailTemporaryCommand',
                'Required parameter "sendLeadEmailTemporaryCommand" was null or undefined when calling sendLeadEmailTemporary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/leads/send-email-temporary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendLeadEmailTemporaryCommandToJSON(requestParameters['sendLeadEmailTemporaryCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * TEMPORARY - Send an email from a lead (POC)
     * Send email from lead (temporary)
     */
    async sendLeadEmailTemporary(requestParameters: SendLeadEmailTemporaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.sendLeadEmailTemporaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
